// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"2734ca87563a579ce476","936":"4948b0d61762a0a149d4"}[chunkId] + "/css/" + (chunkId === 57 ? "index" : chunkId) + ".css";
};